import { createContext, ReactNode } from "react";
import { useAuth } from "@admin/hooks/use-auth";

export const AuthContext = createContext<ReturnType<typeof useAuth> | null>(null);

interface AuthProviderProps {
	children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
	const auth = useAuth();

	return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}
